import { render, staticRenderFns } from "./SpecificationInsertingArticle.vue?vue&type=template&id=2d9f4ba9"
import script from "./SpecificationInsertingArticle.vue?vue&type=script&lang=js"
export * from "./SpecificationInsertingArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports